// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * InvoiceAttributes type.
 * @typedef {object} InvoiceAttributes
 * @property {string} id - Attribute value.
 * @property {number | null} amountCents - Attribute value.
 * @property {string} amountCurrency - Attribute value.
 * @property {number} amountTotal - Attribute value.
 * @property {number} amountVat - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {string | null} creditorId - Attribute value.
 * @property {Date | null} date - Attribute value.
 * @property {string | null} invoiceNo - Attribute value.
 * @property {string | null} invoiceType - Attribute value.
 * @property {boolean} noVat - Attribute value.
 * @property {string | null} organizationId - Attribute value.
 * @property {Date | null} paymentAt - Attribute value.
 * @property {string} pdfFilename - Attribute value.
 * @property {string | null} state - Attribute value.
 * @property {string | null} title - Attribute value.
 * @property {string} translatedInvoiceType - Attribute value.
 * @property {string} translatedState - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 * @property {string | null} userId - Attribute value.
 */
/**
 * Attributes accepted by InvoiceCreateAttributes.
 * @typedef {object} InvoiceCreateAttributes
 * @property {InvoiceAttributes["amountCents"] | null} [amountCents] - Permitted amountCents value.
 * @property {InvoiceAttributes["amountCurrency"] | null} [amountCurrency] - Permitted amountCurrency value.
 * @property {InvoiceAttributes["creditorId"] | null} [creditorId] - Permitted creditorId value.
 * @property {Date | string | null} [date] - Permitted date value.
 * @property {InvoiceAttributes["invoiceNo"] | null} [invoiceNo] - Permitted invoiceNo value.
 * @property {InvoiceAttributes["invoiceType"] | null} [invoiceType] - Permitted invoiceType value.
 * @property {InvoiceAttributes["noVat"] | null} [noVat] - Permitted noVat value.
 * @property {InvoiceAttributes["organizationId"] | null} [organizationId] - Permitted organizationId value.
 * @property {Date | string | null} [paymentAt] - Permitted paymentAt value.
 * @property {InvoiceAttributes["state"] | null} [state] - Permitted state value.
 * @property {InvoiceAttributes["title"] | null} [title] - Permitted title value.
 * @property {InvoiceAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Attributes accepted by InvoiceUpdateAttributes.
 * @typedef {object} InvoiceUpdateAttributes
 * @property {InvoiceAttributes["amountCents"] | null} [amountCents] - Permitted amountCents value.
 * @property {InvoiceAttributes["amountCurrency"] | null} [amountCurrency] - Permitted amountCurrency value.
 * @property {InvoiceAttributes["creditorId"] | null} [creditorId] - Permitted creditorId value.
 * @property {Date | string | null} [date] - Permitted date value.
 * @property {InvoiceAttributes["invoiceNo"] | null} [invoiceNo] - Permitted invoiceNo value.
 * @property {InvoiceAttributes["invoiceType"] | null} [invoiceType] - Permitted invoiceType value.
 * @property {InvoiceAttributes["noVat"] | null} [noVat] - Permitted noVat value.
 * @property {InvoiceAttributes["organizationId"] | null} [organizationId] - Permitted organizationId value.
 * @property {Date | string | null} [paymentAt] - Permitted paymentAt value.
 * @property {InvoiceAttributes["state"] | null} [state] - Permitted state value.
 * @property {InvoiceAttributes["title"] | null} [title] - Permitted title value.
 * @property {InvoiceAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Frontend model for Invoice.
 * @augments {FrontendModelBase<InvoiceAttributes, InvoiceCreateAttributes, InvoiceUpdateAttributes, InvoiceAttributes["id"], string>}
 */
class Invoice extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "Invoice",
      attributes: [
        "id",
        "amountCents",
        "amountCurrency",
        "amountTotal",
        "amountVat",
        "createdAt",
        "creditorId",
        "date",
        "invoiceNo",
        "invoiceType",
        "noVat",
        "organizationId",
        "paymentAt",
        "pdfFilename",
        "state",
        "title",
        "translatedInvoiceType",
        "translatedState",
        "updatedAt",
        "userId",
      ],
      collectionCommands: [
        "createBill",
      ],
      memberCommands: [
        "addUninvoicedTimelogs",
        "finish",
        "pdf",
        "registerAsPaid",
        "registerAsSent",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      creditor: {type: "belongsTo"},
      invoiceGroupLinks: {type: "hasMany"},
      invoiceGroups: {type: "hasMany"},
      invoiceLines: {type: "hasMany"},
      organization: {type: "belongsTo"},
      uploadedFiles: {type: "hasMany"},
      user: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      creditor: "Organization",
      invoiceGroupLinks: "InvoiceGroupLink",
      invoiceGroups: "InvoiceGroup",
      invoiceLines: "InvoiceLine",
      organization: "Organization",
      uploadedFiles: "UploadedFile",
      user: "User",
    }
  }

  /** @returns {InvoiceAttributes["id"]} - Attribute value. */
  id() { return /** @type {InvoiceAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {InvoiceAttributes["id"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {InvoiceAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {InvoiceAttributes["amountCents"]} - Attribute value. */
  amountCents() { return /** @type {InvoiceAttributes["amountCents"]} */ (this.readAttribute("amountCents")) }

  /**
   * @param {InvoiceAttributes["amountCents"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["amountCents"] | null} - Assigned value.
   */
  setAmountCents(newValue) { return /** @type {InvoiceAttributes["amountCents"] | null} */ (this.setAttribute("amountCents", newValue)) }

  /** @returns {InvoiceAttributes["amountCurrency"]} - Attribute value. */
  amountCurrency() { return /** @type {InvoiceAttributes["amountCurrency"]} */ (this.readAttribute("amountCurrency")) }

  /**
   * @param {InvoiceAttributes["amountCurrency"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["amountCurrency"] | null} - Assigned value.
   */
  setAmountCurrency(newValue) { return /** @type {InvoiceAttributes["amountCurrency"] | null} */ (this.setAttribute("amountCurrency", newValue)) }

  /** @returns {InvoiceAttributes["amountTotal"]} - Attribute value. */
  amountTotal() { return /** @type {InvoiceAttributes["amountTotal"]} */ (this.readAttribute("amountTotal")) }

  /**
   * @param {InvoiceAttributes["amountTotal"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["amountTotal"] | null} - Assigned value.
   */
  setAmountTotal(newValue) { return /** @type {InvoiceAttributes["amountTotal"] | null} */ (this.setAttribute("amountTotal", newValue)) }

  /** @returns {InvoiceAttributes["amountVat"]} - Attribute value. */
  amountVat() { return /** @type {InvoiceAttributes["amountVat"]} */ (this.readAttribute("amountVat")) }

  /**
   * @param {InvoiceAttributes["amountVat"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["amountVat"] | null} - Assigned value.
   */
  setAmountVat(newValue) { return /** @type {InvoiceAttributes["amountVat"] | null} */ (this.setAttribute("amountVat", newValue)) }

  /** @returns {InvoiceAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {InvoiceAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {InvoiceAttributes["creditorId"]} - Attribute value. */
  creditorId() { return /** @type {InvoiceAttributes["creditorId"]} */ (this.readAttribute("creditorId")) }

  /**
   * @param {InvoiceAttributes["creditorId"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["creditorId"] | null} - Assigned value.
   */
  setCreditorId(newValue) { return /** @type {InvoiceAttributes["creditorId"] | null} */ (this.setAttribute("creditorId", newValue)) }

  /** @returns {InvoiceAttributes["date"]} - Attribute value. */
  date() { return /** @type {InvoiceAttributes["date"]} */ (this.readAttribute("date")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setDate(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("date", newValue)) }

  /** @returns {InvoiceAttributes["invoiceNo"]} - Attribute value. */
  invoiceNo() { return /** @type {InvoiceAttributes["invoiceNo"]} */ (this.readAttribute("invoiceNo")) }

  /**
   * @param {InvoiceAttributes["invoiceNo"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["invoiceNo"] | null} - Assigned value.
   */
  setInvoiceNo(newValue) { return /** @type {InvoiceAttributes["invoiceNo"] | null} */ (this.setAttribute("invoiceNo", newValue)) }

  /** @returns {InvoiceAttributes["invoiceType"]} - Attribute value. */
  invoiceType() { return /** @type {InvoiceAttributes["invoiceType"]} */ (this.readAttribute("invoiceType")) }

  /**
   * @param {InvoiceAttributes["invoiceType"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["invoiceType"] | null} - Assigned value.
   */
  setInvoiceType(newValue) { return /** @type {InvoiceAttributes["invoiceType"] | null} */ (this.setAttribute("invoiceType", newValue)) }

  /** @returns {InvoiceAttributes["noVat"]} - Attribute value. */
  noVat() { return /** @type {InvoiceAttributes["noVat"]} */ (this.readAttribute("noVat")) }

  /**
   * @param {InvoiceAttributes["noVat"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["noVat"] | null} - Assigned value.
   */
  setNoVat(newValue) { return /** @type {InvoiceAttributes["noVat"] | null} */ (this.setAttribute("noVat", newValue)) }

  /** @returns {InvoiceAttributes["organizationId"]} - Attribute value. */
  organizationId() { return /** @type {InvoiceAttributes["organizationId"]} */ (this.readAttribute("organizationId")) }

  /**
   * @param {InvoiceAttributes["organizationId"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["organizationId"] | null} - Assigned value.
   */
  setOrganizationId(newValue) { return /** @type {InvoiceAttributes["organizationId"] | null} */ (this.setAttribute("organizationId", newValue)) }

  /** @returns {InvoiceAttributes["paymentAt"]} - Attribute value. */
  paymentAt() { return /** @type {InvoiceAttributes["paymentAt"]} */ (this.readAttribute("paymentAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setPaymentAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("paymentAt", newValue)) }

  /** @returns {InvoiceAttributes["pdfFilename"]} - Attribute value. */
  pdfFilename() { return /** @type {InvoiceAttributes["pdfFilename"]} */ (this.readAttribute("pdfFilename")) }

  /**
   * @param {InvoiceAttributes["pdfFilename"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["pdfFilename"] | null} - Assigned value.
   */
  setPdfFilename(newValue) { return /** @type {InvoiceAttributes["pdfFilename"] | null} */ (this.setAttribute("pdfFilename", newValue)) }

  /** @returns {InvoiceAttributes["state"]} - Attribute value. */
  state() { return /** @type {InvoiceAttributes["state"]} */ (this.readAttribute("state")) }

  /**
   * @param {InvoiceAttributes["state"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["state"] | null} - Assigned value.
   */
  setState(newValue) { return /** @type {InvoiceAttributes["state"] | null} */ (this.setAttribute("state", newValue)) }

  /** @returns {InvoiceAttributes["title"]} - Attribute value. */
  title() { return /** @type {InvoiceAttributes["title"]} */ (this.readAttribute("title")) }

  /**
   * @param {InvoiceAttributes["title"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["title"] | null} - Assigned value.
   */
  setTitle(newValue) { return /** @type {InvoiceAttributes["title"] | null} */ (this.setAttribute("title", newValue)) }

  /** @returns {InvoiceAttributes["translatedInvoiceType"]} - Attribute value. */
  translatedInvoiceType() { return /** @type {InvoiceAttributes["translatedInvoiceType"]} */ (this.readAttribute("translatedInvoiceType")) }

  /**
   * @param {InvoiceAttributes["translatedInvoiceType"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["translatedInvoiceType"] | null} - Assigned value.
   */
  setTranslatedInvoiceType(newValue) { return /** @type {InvoiceAttributes["translatedInvoiceType"] | null} */ (this.setAttribute("translatedInvoiceType", newValue)) }

  /** @returns {InvoiceAttributes["translatedState"]} - Attribute value. */
  translatedState() { return /** @type {InvoiceAttributes["translatedState"]} */ (this.readAttribute("translatedState")) }

  /**
   * @param {InvoiceAttributes["translatedState"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["translatedState"] | null} - Assigned value.
   */
  setTranslatedState(newValue) { return /** @type {InvoiceAttributes["translatedState"] | null} */ (this.setAttribute("translatedState", newValue)) }

  /** @returns {InvoiceAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {InvoiceAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /** @returns {InvoiceAttributes["userId"]} - Attribute value. */
  userId() { return /** @type {InvoiceAttributes["userId"]} */ (this.readAttribute("userId")) }

  /**
   * @param {InvoiceAttributes["userId"] | null} newValue - New attribute value.
   * @returns {InvoiceAttributes["userId"] | null} - Assigned value.
   */
  setUserId(newValue) { return /** @type {InvoiceAttributes["userId"] | null} */ (this.setAttribute("userId", newValue)) }

  /**
   * Runs createBill.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{invoiceId: string, redirectPath: string}>} - Command response.
   */
  static async createBill(...commandArguments) {
    return /** @type {{invoiceId: string, redirectPath: string}} */ (await this.executeCustomCommand({
      commandName: "create-bill",
      commandType: "create-bill",
      payload: Invoice.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs addUninvoicedTimelogs.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{createdCount: number, id: string}>} - Command response.
   */
  async addUninvoicedTimelogs(...commandArguments) {
    return /** @type {{createdCount: number, id: string}} */ (await Invoice.executeCustomCommand({
      commandName: "add-uninvoiced-timelogs",
      commandType: "add-uninvoiced-timelogs",
      memberId: this.scalarPrimaryKeyValue("Custom member command Invoice#addUninvoicedTimelogs"),
      payload: Invoice.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Invoice.resourcePath()
    }))
  }

  /**
   * Runs finish.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{id: string, state: string}>} - Command response.
   */
  async finish(...commandArguments) {
    return /** @type {{id: string, state: string}} */ (await Invoice.executeCustomCommand({
      commandName: "finish",
      commandType: "finish",
      memberId: this.scalarPrimaryKeyValue("Custom member command Invoice#finish"),
      payload: Invoice.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Invoice.resourcePath()
    }))
  }

  /**
   * Runs pdf.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{contentBase64: string, contentType: string, filename: string}>} - Command response.
   */
  async pdf(...commandArguments) {
    return /** @type {{contentBase64: string, contentType: string, filename: string}} */ (await Invoice.executeCustomCommand({
      commandName: "pdf",
      commandType: "pdf",
      memberId: this.scalarPrimaryKeyValue("Custom member command Invoice#pdf"),
      payload: Invoice.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Invoice.resourcePath()
    }))
  }

  /**
   * Runs registerAsPaid.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{id: string, state: string}>} - Command response.
   */
  async registerAsPaid(...commandArguments) {
    return /** @type {{id: string, state: string}} */ (await Invoice.executeCustomCommand({
      commandName: "register-as-paid",
      commandType: "register-as-paid",
      memberId: this.scalarPrimaryKeyValue("Custom member command Invoice#registerAsPaid"),
      payload: Invoice.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Invoice.resourcePath()
    }))
  }

  /**
   * Runs registerAsSent.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{id: string, state: string}>} - Command response.
   */
  async registerAsSent(...commandArguments) {
    return /** @type {{id: string, state: string}} */ (await Invoice.executeCustomCommand({
      commandName: "register-as-sent",
      commandType: "register-as-sent",
      memberId: this.scalarPrimaryKeyValue("Custom member command Invoice#registerAsSent"),
      payload: Invoice.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Invoice.resourcePath()
    }))
  }

  /**
   * Returns creditor relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Invoice, import("./organization.js").Organization, import("./organization.js").OrganizationCreateAttributes>} - Relationship helper.
   */
  creditorRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Invoice, import("./organization.js").Organization, import("./organization.js").OrganizationCreateAttributes>} */ (this.getRelationshipByName("creditor")) }

  /**
   * Returns creditor.
   * @returns {import("./organization.js").Organization | null} - Loaded related model.
   */
  creditor() { return this.creditorRelationship().loaded() }

  /**
   * Builds creditor.
   * @param {import("./organization.js").OrganizationCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./organization.js").Organization} - Built related model.
   */
  buildCreditor(attributes = {}) { return this.creditorRelationship().build(attributes) }

  /**
   * Loads creditor.
   * @returns {Promise<import("./organization.js").Organization | null>} - Loaded related model.
   */
  async loadCreditor() { return await this.creditorRelationship().load() }

  /**
   * Returns or loads creditor.
   * @returns {Promise<import("./organization.js").Organization | null>} - Loaded related model.
   */
  async creditorOrLoad() { return await this.creditorRelationship().orLoad() }

  /**
   * Sets creditor.
   * @param {import("./organization.js").Organization | null} model - Related model.
   * @returns {void}
   */
  setCreditor(model) { this.creditorRelationship().setLoaded(model) }

  /**
   * Returns invoiceGroupLinks relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./invoice-group-link.js").InvoiceGroupLink, import("./invoice-group-link.js").InvoiceGroupLinkCreateAttributes>} - Relationship helper.
   */
  invoiceGroupLinksRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./invoice-group-link.js").InvoiceGroupLink, import("./invoice-group-link.js").InvoiceGroupLinkCreateAttributes>} */ (this.getRelationshipByName("invoiceGroupLinks")) }

  /**
   * Returns invoiceGroupLinks.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./invoice-group-link.js").InvoiceGroupLink, import("./invoice-group-link.js").InvoiceGroupLinkCreateAttributes>} - Relationship helper.
   */
  invoiceGroupLinks() { return this.invoiceGroupLinksRelationship() }

  /**
   * Returns loaded invoiceGroupLinks.
   * @returns {Array<import("./invoice-group-link.js").InvoiceGroupLink>} - Loaded related models.
   */
  invoiceGroupLinksLoaded() { return this.invoiceGroupLinksRelationship().loaded() }

  /**
   * Loads invoiceGroupLinks.
   * @returns {Promise<Array<import("./invoice-group-link.js").InvoiceGroupLink>>} - Loaded related models.
   */
  async loadInvoiceGroupLinks() { return await this.invoiceGroupLinksRelationship().load() }

  /**
   * Returns invoiceGroups relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./invoice-group.js").InvoiceGroup, import("./invoice-group.js").InvoiceGroupCreateAttributes>} - Relationship helper.
   */
  invoiceGroupsRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./invoice-group.js").InvoiceGroup, import("./invoice-group.js").InvoiceGroupCreateAttributes>} */ (this.getRelationshipByName("invoiceGroups")) }

  /**
   * Returns invoiceGroups.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./invoice-group.js").InvoiceGroup, import("./invoice-group.js").InvoiceGroupCreateAttributes>} - Relationship helper.
   */
  invoiceGroups() { return this.invoiceGroupsRelationship() }

  /**
   * Returns loaded invoiceGroups.
   * @returns {Array<import("./invoice-group.js").InvoiceGroup>} - Loaded related models.
   */
  invoiceGroupsLoaded() { return this.invoiceGroupsRelationship().loaded() }

  /**
   * Loads invoiceGroups.
   * @returns {Promise<Array<import("./invoice-group.js").InvoiceGroup>>} - Loaded related models.
   */
  async loadInvoiceGroups() { return await this.invoiceGroupsRelationship().load() }

  /**
   * Returns invoiceLines relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./invoice-line.js").InvoiceLine, import("./invoice-line.js").InvoiceLineCreateAttributes>} - Relationship helper.
   */
  invoiceLinesRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./invoice-line.js").InvoiceLine, import("./invoice-line.js").InvoiceLineCreateAttributes>} */ (this.getRelationshipByName("invoiceLines")) }

  /**
   * Returns invoiceLines.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./invoice-line.js").InvoiceLine, import("./invoice-line.js").InvoiceLineCreateAttributes>} - Relationship helper.
   */
  invoiceLines() { return this.invoiceLinesRelationship() }

  /**
   * Returns loaded invoiceLines.
   * @returns {Array<import("./invoice-line.js").InvoiceLine>} - Loaded related models.
   */
  invoiceLinesLoaded() { return this.invoiceLinesRelationship().loaded() }

  /**
   * Loads invoiceLines.
   * @returns {Promise<Array<import("./invoice-line.js").InvoiceLine>>} - Loaded related models.
   */
  async loadInvoiceLines() { return await this.invoiceLinesRelationship().load() }

  /**
   * Returns organization relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Invoice, import("./organization.js").Organization, import("./organization.js").OrganizationCreateAttributes>} - Relationship helper.
   */
  organizationRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Invoice, import("./organization.js").Organization, import("./organization.js").OrganizationCreateAttributes>} */ (this.getRelationshipByName("organization")) }

  /**
   * Returns organization.
   * @returns {import("./organization.js").Organization | null} - Loaded related model.
   */
  organization() { return this.organizationRelationship().loaded() }

  /**
   * Builds organization.
   * @param {import("./organization.js").OrganizationCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./organization.js").Organization} - Built related model.
   */
  buildOrganization(attributes = {}) { return this.organizationRelationship().build(attributes) }

  /**
   * Loads organization.
   * @returns {Promise<import("./organization.js").Organization | null>} - Loaded related model.
   */
  async loadOrganization() { return await this.organizationRelationship().load() }

  /**
   * Returns or loads organization.
   * @returns {Promise<import("./organization.js").Organization | null>} - Loaded related model.
   */
  async organizationOrLoad() { return await this.organizationRelationship().orLoad() }

  /**
   * Sets organization.
   * @param {import("./organization.js").Organization | null} model - Related model.
   * @returns {void}
   */
  setOrganization(model) { this.organizationRelationship().setLoaded(model) }

  /**
   * Returns uploadedFiles relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./uploaded-file.js").UploadedFile, import("./uploaded-file.js").UploadedFileCreateAttributes>} - Relationship helper.
   */
  uploadedFilesRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./uploaded-file.js").UploadedFile, import("./uploaded-file.js").UploadedFileCreateAttributes>} */ (this.getRelationshipByName("uploadedFiles")) }

  /**
   * Returns uploadedFiles.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Invoice, import("./uploaded-file.js").UploadedFile, import("./uploaded-file.js").UploadedFileCreateAttributes>} - Relationship helper.
   */
  uploadedFiles() { return this.uploadedFilesRelationship() }

  /**
   * Returns loaded uploadedFiles.
   * @returns {Array<import("./uploaded-file.js").UploadedFile>} - Loaded related models.
   */
  uploadedFilesLoaded() { return this.uploadedFilesRelationship().loaded() }

  /**
   * Loads uploadedFiles.
   * @returns {Promise<Array<import("./uploaded-file.js").UploadedFile>>} - Loaded related models.
   */
  async loadUploadedFiles() { return await this.uploadedFilesRelationship().load() }

  /**
   * Returns user relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Invoice, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  userRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Invoice, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("user")) }

  /**
   * Returns user.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  user() { return this.userRelationship().loaded() }

  /**
   * Builds user.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildUser(attributes = {}) { return this.userRelationship().build(attributes) }

  /**
   * Loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadUser() { return await this.userRelationship().load() }

  /**
   * Returns or loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async userOrLoad() { return await this.userRelationship().orLoad() }

  /**
   * Sets user.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setUser(model) { this.userRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(Invoice)

export {Invoice}

export default Invoice
